var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"support card"},[_c('div',[_c('portal',{attrs:{"to":"page-call-to-action"}},[(_vm.$isAdmin)?_c('ebp-button',{on:{"click":_vm.edit}},[_vm._v(_vm._s(_vm.$t("edit")))]):_vm._e()],1)],1),_c('div',{staticClass:"card-body"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }